import React, { useEffect, useRef } from "react";

const FlowStickyHeader = ({ children }) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const scope = node.closest(".sy-flow") || node.parentElement;
    if (!scope) return undefined;

    const publish = () =>
      scope.style.setProperty("--flow-sticky-h", `${Math.round(node.offsetHeight)}px`);

    publish();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", publish);
      return () => {
        window.removeEventListener("resize", publish);
        scope.style.removeProperty("--flow-sticky-h");
      };
    }

    const observer = new ResizeObserver(publish);
    observer.observe(node);

    return () => {
      observer.disconnect();
      scope.style.removeProperty("--flow-sticky-h");
    };
  }, []);

  return (
    <div className="sy-flow-sticky" ref={ref}>
      {children}
    </div>
  );
};

export default FlowStickyHeader;
